module.exports = __webpack_public_path__ + "img/H2F1.f38b02c4.jpg";